/** Local search over already-authorized records; never expands the server scope. */
export function normalizeDirectorySearch(value: string): string {
  return value.normalize("NFKD").replace(/\p{M}/gu, "")
    .replace(/[يى]/g, "ی").replace(/ك/g, "ک")
    .replace(/[۰-۹٠-٩]/g, (digit) => String(digit.charCodeAt(0) - (digit >= "۰" ? 1776 : 1632)))
    .replace(/[\u200c\u200d_\-]+/g, " ").toLowerCase().replace(/\s+/g, " ").trim();
}

export function matchesDirectorySearch(query: string, ...fields: Array<string | null | undefined>): boolean {
  const text = normalizeDirectorySearch(fields.filter(Boolean).join(" "));
  return normalizeDirectorySearch(query).split(" ").filter(Boolean).every((term) => text.includes(term));
}

function oneEditApart(a: string, b: string): boolean {
  if (Math.abs(a.length - b.length) > 1) return false;
  if (a.length === b.length) {
    const differences = [...a].map((letter, index) => letter === b[index] ? -1 : index).filter((index) => index >= 0);
    return differences.length === 1 || (differences.length === 2
      && differences[1] === differences[0]! + 1
      && a[differences[0]!] === b[differences[1]!]
      && a[differences[1]!] === b[differences[0]!]);
  }
  const [shorter, longer] = a.length < b.length ? [a, b] : [b, a];
  let index = 0;
  while (index < shorter.length && shorter[index] === longer[index]) index += 1;
  return shorter.slice(index) === longer.slice(index + 1);
}

/** Explicit correction only. Callers must never silently apply a guessed query. */
export function suggestDirectoryQuery(query: string, labels: string[]): string | null {
  const normalized = normalizeDirectorySearch(query);
  if (normalized.length < 4 || normalized.includes(" ")) return null;
  const words = [...new Set(labels.flatMap((label) => normalizeDirectorySearch(label).split(" ")))];
  const candidates = words.filter((word) => word.length >= 4 && oneEditApart(normalized, word));
  return candidates.length === 1 ? candidates[0]! : null;
}
